import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/registro',
    name: 'registro',
    component: () => import('../views/Registro.vue')
  },
  {
    path: '/link/:id',
    name: 'link',
    component: () => import('../views/Link.vue')
  },
  {
    path: '/micarta/:id',
    name: 'micarta',
    component: () => import('../views/MiCarta.vue')
  },
  {
    path: '/sent',
    name: 'sent',
    component: () => import('../views/Sent.vue')
  },
  {
    path: '/vercarta/:id',
    name: 'vercarta',
    component: () => import('../views/VerCarta.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
